module.exports = __webpack_public_path__ + "img/poster.d474f6de.png";